import {
  UPDATE_EVENTS,
  SET_SEASON,
  SET_EVENT_TYPE,
  SET_MONTH,
  SET_TOURNAMENT,
  LOAD_MORE_EVENTS,
  SET_LOADING,
  RELOAD_EVENTS,
} from './filters_constants';
import { buildLocalizedUrl } from '../../../utils/locale';

export const eventsSet = (payload) => ({
  type: UPDATE_EVENTS,
  payload,
});

export const seasonSet = (season) => ({
  type: SET_SEASON,
  season,
});

export const eventTypeSet = (payload) => ({
  type: SET_EVENT_TYPE,
  payload,
});

export const monthSet = (payload) => ({
  type: SET_MONTH,
  payload,
});

export const tournamentSet = (tournament) => ({
  type: SET_TOURNAMENT,
  tournament,
});

export const loadMoreEvents = (payload) => ({
  type: LOAD_MORE_EVENTS,
  payload,
});

export const setLoading = (loading) => ({
  type: SET_LOADING,
  loading,
});

export const reloadEvents = (payload) => ({
  type: RELOAD_EVENTS,
  payload,
});

// Async action to reload events with filters
export const reloadEventsWithFilters = (selectedType, selectedSeason, selectedMonth, selectedTournament) => {
  return async (dispatch) => {
    dispatch(setLoading(true));

    try {
      // Build query parameters with current filters
      const params = new URLSearchParams({
        page: 1,
        per_page: 10
      });

      // Add filter parameters
      if (selectedType && selectedType.value !== 'All') {
        params.append('type', selectedType.value);
      }

      if (selectedSeason && selectedSeason !== 0) {
        params.append('season', selectedSeason);
      }

      if (selectedMonth && selectedMonth.value !== 'All') {
        params.append('month', selectedMonth.value);
      }

      if (selectedTournament) {
        params.append('tournament_id', selectedTournament);
      }

      const response = await fetch(`${buildLocalizedUrl('scheduler.json')}?${params.toString()}`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      });
      
      if (response.ok) {
        const data = await response.json();
        dispatch(reloadEvents(data));
      } else if (typeof window !== 'undefined' && window.TeamforceNotifications) {
        window.TeamforceNotifications.handleJsonResponse(response, { showSuccess: false });
      }
    } catch (error) {
      console.error('Error reloading events:', error);
      if (typeof window !== 'undefined' && window.showNotification) {
        const fallback = (document.body && document.body.dataset && document.body.dataset.i18nRequestFailed)
          || 'Failed to load events.';
        window.showNotification(fallback, 'error');
      }
    } finally {
      dispatch(setLoading(false));
    }
  };
};

// Combined actions that update filter and reload events
export const setEventTypeAndReload = (eventType) => {
  return async (dispatch, getState) => {
    dispatch(eventTypeSet(eventType));
    const state = getState();
    dispatch(reloadEventsWithFilters(eventType, state.events.selectedSeason, state.events.selectedMonth, state.events.selectedTournament));
  };
};

export const setSeasonAndReload = (season, tournament) => {
  return async (dispatch, getState) => {
    dispatch(seasonSet(season));
    if (tournament !== undefined) {
      dispatch(tournamentSet(tournament));
    }
    const state = getState();
    const effectiveTournament = tournament !== undefined ? tournament : state.events.selectedTournament;
    dispatch(reloadEventsWithFilters(state.events.selectedType, season, state.events.selectedMonth, effectiveTournament));
  };
};

export const setMonthAndReload = (month) => {
  return async (dispatch, getState) => {
    dispatch(monthSet(month));
    const state = getState();
    dispatch(reloadEventsWithFilters(state.events.selectedType, state.events.selectedSeason, month, state.events.selectedTournament));
  };
};

export const setTournamentAndReload = (tournament) => {
  return async (dispatch, getState) => {
    dispatch(tournamentSet(tournament));
    const state = getState();
    dispatch(reloadEventsWithFilters(state.events.selectedType, state.events.selectedSeason, state.events.selectedMonth, tournament));
  };
};
